import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Button } from 'antd';
import { apiConfig, apiGetPage, apiGetCustom } from '../../request/api';
import { SendOutlined, SwapRightOutlined } from '@ant-design/icons';
import { useCustomData } from '../../pages/context/indexCustomDataContext';
import '../../assets/css/home.css';

interface PageData {
    mainTitle: string;
    mainInfo: string;
    createdAt?: string;
}

const HomePart2: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [partList, setPartList] = useState<PageData[]>([]);
    const [hoverIndex, setHoverIndex] = useState<number>(0); // 初始化为-1，表示没有hover任何项目
    const [title, setTitle] = useState<string>('');
    const { getValue } = useCustomData();
    const knowMore = getValue('knowMore');

    useEffect(() => {
        apiGetCustom({
            pageId: '5A711777462348DDB9B577745DE444AD',
            languageCode,
            size: 100,
            s: 'indexFourth'
        }).then(res => {
            console.log(res)
            if (Array.isArray(res.data?.data)) {
                const rows = res.data.data;

                // 提取主标题
                const mainTitleItem = rows.find((item: { code: string; }) => item.code === 'indexFourthTitle');
                console.log(mainTitleItem)
                if (mainTitleItem) {
                    setTitle(mainTitleItem.value);
                }

                // 筛选出标题和内容项
                const titles = rows.filter((item: { code: string; }) => item.code.startsWith('indexFourthTitle') && item.code !== 'indexFourthTitle');
                const contents = rows.filter((item: { code: string; }) => item.code.startsWith('indexFourthContent'));


                // 根据 description 进行匹配组合
                const combinedList: PageData[] = titles.map((titleItem: any) => {
                    const matchedContent = contents.find((contentItem: any) => contentItem.description === titleItem.description);
                    return {
                        mainTitle: titleItem.value,
                        mainInfo: matchedContent?.value || '',
                        createdAt: titleItem.createdAt, // 加上创建时间用于排序
                    };
                }).sort((a: { createdAt: string | number | Date; }, b: { createdAt: string | number | Date; }) => {
                    // 时间升序排序
                    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
                });

                setPartList(combinedList);
            }
        });
    }, []);

    const handleMouseOver = (index: number) => {
        setHoverIndex(index);
    };

    // const handleMouseOut = () => {
    //     setHoverIndex(-1);
    // };

    const getCurrentItem = () => {
        return hoverIndex !== -1 ? partList[hoverIndex] : null;
    };

    return (
        <div className="home-part2">
            <div className='part2-left'>
                <div className='part2-left_title'>{title}</div>
                {partList.map((item, index) => (
                    <div
                        className="part2-left_item"
                        onMouseOver={() => handleMouseOver(index)}
                        key={index}
                        // onMouseOut={handleMouseOut}
                        style={{
                            color: index === hoverIndex ? themeColor : '#33364b'
                        }}
                    >
                        <SendOutlined style={{ color: themeColor, fontSize: '20px' }} />
                        <div className='part2-left_item_middle'>{item.mainTitle}</div>
                        <SwapRightOutlined style={{ fontSize: '20px' }} />
                    </div>
                ))}
                <div className="part2-left_bottom">
                    <Button type="primary" onClick={() => navigate('/service', { state: { initialView: 'service-home' } })}>{knowMore}</Button>
                </div>
            </div>
            <div className='part2-right' style={{ backgroundColor: themeColor }}>
                {getCurrentItem() ? (
                    <>
                        <div className='part2-right_top'>
                            <div className='part2-right_top_left'>{getCurrentItem()?.mainTitle}</div>
                        </div>
                        <div className='part2-right-bottom'>
                            {getCurrentItem()?.mainInfo}
                        </div>
                    </>
                ) : (
                    <div>请选择一项服务</div>
                )}
            </div>
        </div>
    );
};

export default HomePart2;